import { createSelector } from 'reselect'

// import { createSelector } from 'reselect'

export const getLoader = (state) => state.loader

export const isLoading = createSelector([getLoader], ({ loading }) => loading)

export const getProgress = createSelector([getLoader], ({ progress }) => progress)

export const getShowLoadingBar = createSelector([getLoader], ({ showLoadingBar }) => showLoadingBar)

export const getActiveLoaders = createSelector([getLoader], ({ activeLoaders }) => activeLoaders)
